import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';
import { Chip } from '@shared/components';
import { Box } from '@mui/system';
import { firstColumnSize, secondColumnSize } from './MgItemView';

export interface Props {
  label?: string;
}

export const MgItemDetailsProductGroup = ({ label }: Props) => {
  const theme = useTheme();
  const { breakpoints } = theme;
  const { tint } = theme.vars.palette.semantic;
  const t = useProductsTFunction();

  const isLessThanLarge = useMediaQuery(breakpoints.down('lg'));
  const isLessThanMedium = useMediaQuery(breakpoints.down('md'));

  return (
    <>
      <Grid fontWeight={600} size={firstColumnSize}>
        {t('products.search.productGroup.label')}
      </Grid>
      <Grid fontWeight="medium" color="text.secondary" size={secondColumnSize}>
        {label ? (
          <Box display="flex" alignItems="center">
            <Chip
              backgroundColor={tint.green.soft}
              textColor={tint.green.text}
              label={
                isLessThanLarge ? (
                  <Typography
                    variant="body2"
                    sx={{
                      maxWidth: isLessThanMedium ? 120 : 200,
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                    }}
                  >
                    {label}
                  </Typography>
                ) : (
                  label
                )
              }
            />
          </Box>
        ) : (
          ''
        )}
      </Grid>
    </>
  );
};
